import { PACKAGES_FETCH_REQUEST, PACKAGES_FETCH_SUCCESS, PACKAGES_FETCH_FAILURE } from './types';

const initialState = {
    loading: false,
    packages: {},
    error: ''
}

const packages = (state = initialState, action) => {
    switch (action.type) {
        case PACKAGES_FETCH_REQUEST:
            return {
                loading: true,
                packages: {},
                error: '',
            }
        case PACKAGES_FETCH_SUCCESS:
            return {
                loading: false,
                packages: action.payload,
                error: ''
            }
        case PACKAGES_FETCH_FAILURE:
            return {
                loading: false,
                packages: {},
                error: action.payload
            }
        default: return state
    }
}

export default packages;